import { IAppConfigDataModel } from '../../data-models/app-config.data-model';
import { MaggieHttp } from '../MaggieHttp';

export async function fetchAppConfig() {
  const response = await MaggieHttp.maggie.get<IAppConfigDataModel>('/configuration');

  return response.data;
}
